/**
 * Mimu — reserve exactly as much space at the end of the page as the sticky bundle
 * bar actually occupies.
 *
 * The bar is fixed, so the page needs padding underneath or the last of the content
 * sits behind it. That padding was a hardcoded guess (84px, then 104, then 118 as
 * the bar grew), and a guess that overshoots shows up as dead space at the bottom
 * of the page. This measures the bar instead, so the reservation is always right.
 *
 * Deliberately does NOT try to reposition the bar. An earlier attempt to correct
 * for Chrome Android's retracting toolbar by offsetting `bottom` overshot and drove
 * the bar off-screen, so that idea is out until it can be measured on a real device.
 */
(function () {
  var bar = document.querySelector('[data-mimu-sticky]');
  if (!bar) return;

  var applied = null;
  var scheduled = false;

  function fit() {
    // Hidden bar reserves nothing.
    if (bar.hidden) {
      if (applied !== 0) {
        applied = 0;
        document.documentElement.style.removeProperty('--mimu-sticky-height');
      }
      return;
    }

    var height = Math.ceil(bar.getBoundingClientRect().height);
    if (!height || height === applied) return;

    applied = height;
    document.documentElement.style.setProperty('--mimu-sticky-height', height + 'px');
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      fit();
    });
  }

  if (window.ResizeObserver) new ResizeObserver(schedule).observe(bar);
  new MutationObserver(schedule).observe(bar, { attributes: true, attributeFilter: ['hidden'] });
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  setInterval(schedule, 1000);

  schedule();
})();
